import { render, staticRenderFns } from "./addBrand.vue?vue&type=template&id=a004b11e"
import script from "./addBrand.vue?vue&type=script&lang=ts"
export * from "./addBrand.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports